import React from "react";
import Navbar from "./Navbar";
import style from "./home.module.css";
import fahran from "../../Assets/homepage/fahran.svg";
import girl1 from "../../Assets/homepage/1stgirl.svg";
import blobs from "../../Assets/homepage/recentblob.svg";
import girl2 from "../../Assets/homepage/2ndgirl.svg";
import win from "../../Assets/homepage/window.svg";
import displayRazorpay from "../razerpay/razorpay";
function Homepage(addtocart) {
  return (
    <div>
      <Navbar />
      <div className="flex p-12 justify-between">
        <div className="flex flex-col gap-8 ">
          <div>
            <h1 className="text-4xl pb-2">PHOTOGRAPHY: CAPTURING MOMENTS</h1>
            <span>Dr. Farhan Qureshi</span>
          </div>
          <p className="w-[40vw]">
            A detailed course on photography which teaches from scratch. Master
            the art of capturing moments.
          </p>
          <div className="flex gap-2">
            <p>$1999</p>
            <p className="line-through">$4999</p>
          </div>
          <button
            className="w-32 text-lg bg-[#0A9B0A] p-2 rounded-[1rem]"
            onClick={displayRazorpay}
          >
            Buy Now
          </button>
        </div>
        <div>
          <img className="w-[35vw]" src={fahran} alt="fahran" />
        </div>
      </div>
      <div className="flex p-12">
        <img className="w-[15vw]" src={girl1} alt="girl1" />
        <div>
          <div>
            <h1 className="text-xl">RECENT TEACHING</h1>
          </div>
          <div className="flex gap-8">
            <div className={style.reclern}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero
              nam provident saepe commodi cupiditate pariatur qui magni, quia,
              odio ad labore iste error. Pariatur iste aut numquam eos!
              Provident, distinctio!
            </div>
            <div className={style.reclern}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero
              nam provident saepe commodi cupiditate pariatur qui magni, quia,
              odio ad labore iste error. Pariatur iste aut numquam eos!
              Provident, distinctio!
            </div>
            <div className={style.reclern}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero
              nam provident saepe commodi cupiditate pariatur qui magni, quia,
              odio ad labore iste error. Pariatur iste aut numquam eos!
              Provident, distinctio!
            </div>
            {/* <img className="w-[20vw]" src={blobs} alt="girl1" />
                <img className="w-[20vw]" src={blobs} alt="girl1" />
                <img className="w-[20vw]" src={blobs} alt="girl1" /> */}
          </div>
        </div>
      </div>
      <div className="flex px-8 items-center">
        <img className="w-[20vw]" src={girl2} alt="girl2" />
        <img className="w-[50vw]" src={win} alt=" window" />
      </div>
    </div>
  );
}

export default Homepage;
